import type { ExternalColumnMapInfoInterface } from '@nts/std/interfaces';
import { ExternalFieldInputMode } from "@nts/std/types";

export class ExternalColumnMapInfo implements ExternalColumnMapInfoInterface {
    externalPropertyName: string;
    externalCodesPropertyName: {
        propertyName: string,
        inputMode: ExternalFieldInputMode,
        showCodeInDescription: boolean;
    }[];
    externalDecodesPropertyName: string[];
}
